module.exports = {
    /**
     * Схема для проверки поля ввода "Электронный адрес"
     */
    email: {
        properties: {
            value: {
                type: 'string',
                required: true,
                validator: {
                    func: function (value) {
                        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return value.length < 64 && regex.test(value);
                    },
                    message: 'Неверный формат почты'
                },
                messages: {
                    message: 'Неверный формат почты',
                    emailAlreadyUsed: 'Пользователь с таким email уже зарегистрирован'
                }
            }
        }
    },
    firstName: {
        properties: {
            value: {
                type: 'string',
                required: true,
                minLength: 1,
                message: 'Введите имя'
            }
        }
    },
    lastName: {
        properties: {
            value: {
                type: 'string',
                required: true,
                minLength: 1,
                message: 'Введите фамилию'
            }
        }
    },
    password: {
        properties: {
            value: {
                type: 'string',
                required: true,
                minLength: 6,
                message: 'Минимальная длина пароля – 6 символов'
            }
        }
    },
    repeatPassword: {
        properties: {
            value: {
                type: 'string',
                required: true,
                messages: {
                    repeat: 'Пароли не совпадают'
                }
            }
        }
    },
    // ИНН 10 цифр для юриков, 12 для физиков
    inn10: {
        properties: {
            value: {
                required: false,
                message: 'Введите ИНН (10 цифр)',
                validator: {
                    // https://ru.wikipedia.org/wiki/Идентификационный_номер_налогоплательщика
                    func: function (value) {
                        let n = value.split('');
                        if (n.length !== 10) {
                            return false;
                        }

                        for (let i = 0; i < n.length; i++) {
                            n[i] = parseInt(n[i], 10);
                        }

                        const c10 = [2, 4, 10, 3, 5, 9, 4, 6, 8];
                        let n10 = 0;
                        for (let j = 0; j < 9; j++) {
                            n10 += n[j] * c10[j];
                        }

                        n10 = (n10 % 11) % 10;
                        return n[9] === n10;
                    },
                    message: 'Некорректный ИНН'
                }
            }
        }
    },
    // ИНН 10 цифр для юриков, 12 для физиков
    inn12: {
        properties: {
            value: {
                required: false,
                message: 'Введите ИНН (12 цифр)',
                validator: {
                    // https://ru.wikipedia.org/wiki/Идентификационный_номер_налогоплательщика
                    func: function (value) {
                        let n = value.split('');
                        if (n.length !== 12) {
                            return false;
                        }

                        for (let i = 0; i < n.length; i++) {
                            n[i] = parseInt(n[i], 10);
                        }

                        const c11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
                        const c12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
                        let n11 = 0;
                        let n12 = 0;
                        for (let z = 0; z < 10; z++) {
                            n11 += n[z] * c11[z];
                        }
                        for (let l = 0; l < 11; l++) {
                            n12 += n[l] * c12[l];
                        }

                        n11 = (n11 % 11) % 10;
                        n12 = (n12 % 11) % 10;
                        return n[10] === n11 && n[11] === n12;
                    },
                    message: 'Некорректный ИНН'
                }
            }
        }
    },
    // КПП 9 цифр
    kpp: {
        properties: {
            value: {
                required: false,
                message: 'Введите КПП (9 цифр)',
                pattern: '^([0-9]{9})?$'
            }
        }
    },
    bin: {
        properties: {
            value: {
                required: true,
                message: 'Введите БИН (12 цифр)',
                pattern: '^([0-9]{12})?$'
            }
        }
    },
    number: {
        properties: {
            value: {
                required: false,
                message: 'Введите число',
                pattern: '^\\d*[\\,\\.]?\\d*$'
            }
        }
    },
    numberOrEmpty: {
        properties: {
            value: {
                required: false,
                message: 'Введите число',
                pattern: '(^$|^\\d*[\\,\\.]?\\d*$)'
            }
        }
    },
    // только буквы на любом языке и числа
    stringOnlyLettersAndDigitsNotEmpty: {
        properties: {
            value: {
                type: 'string',
                required: false,
                pattern: '^[а-яА-ЯёЁa-zA-Z0-9 ]+?$',
                message: 'Введите значение'
            }
        }
    }
};



// WEBPACK FOOTER //
// ./helpers/scheme/index.js